import { useMutation, useQueryClient } from 'react-query';

import type { $RuleModel } from '../../../models/rules/RuleModel';
import QUERYKEYS from '../../../constants/queryKeys';
import type { TUpsertModel } from '../../../utils/hookUtils';
import { upsertRule } from './../../../services/RuleService';

const useUpsertRule = (): TUpsertModel<$RuleModel> => {
  const queryClient = useQueryClient();
  const { isError, isLoading, mutate } = useMutation(upsertRule, {
    onSuccess: (data) => {
      if (data) {
        queryClient.setQueryData(QUERYKEYS.RULES, (rules: $RuleModel[] = []) => [
          ...rules.filter((rule: $RuleModel) => rule.id !== data.id),
          data,
        ]);
      }
    },
  });
  return {
    upsert: mutate,
    isError,
    isLoading,
  };
};

export default useUpsertRule;
